import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_RELATED_PETITION_CARD_SHARE = defineFcm('related_petition_card_share')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-platypus',
		scope: 'corgi-front-end',
		context: 'Petition Details Page related petition cards',
		description:
			'Kill switch for the related-petition-card share CTA experiment, independent of Experiment Service assignment.\n\nhttps://change.atlassian.net/browse/CHANGE-94942',
		import: false,
		template: {
			enabled: false,
		},
		deprecated: 'FCM no longer in use — safe to delete after 2026-09-03',
	});
